import { ErrorsService } from "./../../../../services/common/errors.service";
import { TranslateService } from "@ngstack/translate";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSelectChange,
} from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";
import { SoundEnum } from "src/app/enums/sound.enum";
//import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { SnackBarService } from "./../../../../services/common/snackBar.service";
import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
import { AccountService } from "../../../../services/http/business/account/account.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-discount-group-person-entry',
  templateUrl: './discount-group-person-entry.component.html',
  styleUrls: ['./discount-group-person-entry.component.css']
})
export class DiscountGroupPersonEntryComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  personInfo: any;
  errObject: any;
  discount: any;
  form: FormGroup;
  nationalCode: string;
  errors = new Array();
  nationalcodeForm: FormGroup;
  showForm: boolean = true;
  hideNaForm: boolean = false;
  isUpdate:boolean;
  isSuccessFileUpload: any;
  fileList=[];
  discountsType=[];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    public dialogRef: MatDialogRef<DiscountGroupPersonEntryComponent>,
    private accountService:AccountService,
    private discountGroupService : DiscountGroupService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    this.createForm();
    this.createNationalcodeForm();

    if(this.data){

      this.isUpdate=true;
      this.showForm = true;
      this.hideNaForm = true;
    }else{
      this.isUpdate=false;
      this.showForm = false;
      this.hideNaForm = false;
    }
    this.getDiscountsType(false);

  }

  createNationalcodeForm() {
    this.nationalcodeForm = this.fb.group({
      nationalCode: [
          null,
          Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ]
    });
  }

  getDiscountsType(status):any{
    this.discountGroupService.discountByTypeList(status).subscribe(res => {
      this.discountsType = res;
    });
  }

  createForm() {
    this.form = this.fb.group({
      Id:[this.data && this.data.Id ? this.data.Id.toString() : null],
      NationalCode: [this.nationalCode],
      Files:[this.data && this.data.Files ? this.data.Files : null,Validators.required],
      Explain:[],
      DiscountGroupId:[this.data && this.data.DiscountGroupId ? this.data.DiscountGroupId.toString() : null,Validators.required]
    });
  }

  submitNaCode(itemParams: any) {
    this.errors = new Array();
    this.accountService.getSimpleUserInfo(itemParams.nationalCode).subscribe(
      res => {
        this.form.controls["NationalCode"].patchValue(itemParams.nationalCode);
        this.personInfo = res;
        this.showForm = true;
        this.hideNaForm = true;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }
  getDiscount(discountId: MatSelectChange):void{

    this.discount=this.discountsType.find(x => x.Id==discountId);
  }
  onFileChange(event) {
   let files=[];
   for(const element of event.target.files) {
    files.push(element);
  }
      if (files) {
        files.forEach((item,key)=> {
            this.fileList.push({FileDisplayName:item.name});
        if (item.size <= 100000) {
          const reader = new FileReader();
          reader.onload = this._handleReaderLoaded.bind(this,key);
          reader.readAsBinaryString(item);
          this.isSuccessFileUpload=true;

        } else {
          this.isSuccessFileUpload=false;

          this.snackBar.OpenSnackBar(

            this.translate.get("require.fileUpload", {
              size: "100kb"
            }),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
  });
}

  }

  _handleReaderLoaded(key,readerEvt) {
    this.fileList[key].ImageData=btoa(readerEvt.target.result);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit(form:any) {

    this.errors = new Array();
    if (this.isUpdate) {
      let command={
        Id:form.Id,
        DiscountGroupId: form.DiscountGroupId,

      }
      this.discountGroupService.documentChangeDiscountGroup(command).subscribe(() => {

        this.dialogRef.close();
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );

    } else {
      let command={
        NationalCode:  form.NationalCode,
        DiscountGroupId: form.DiscountGroupId,
        Explain:form.Explain,
        FileList: this.fileList

      }
      this.discountGroupService.documentAdd(command).subscribe(() => {

        this.dialogRef.close();
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
    }

  }
}
